import React, { useCallback, useMemo } from 'react'
import '../../styles/pages.css'
import { Box, Button } from '@mui/material'
import { useNavigateTo } from 'infrastructure/routing'
import { Add } from '@mui/icons-material'
import { List } from 'infrastructure/api'
import { PaginatedResourceList } from './resourceList/PaginatedResourceList'
import { useResourceRoutes } from 'shared/api/resourceRouting'
import { Column } from 'shared/ui/Table/types'
import { SortableHeader } from '../utility/SortableHeader'
import { StringFilter } from './resourceList/StringFilter'
import { VerifiedSelect } from './resourceList/SelectFilter'
import { SwitchFilter } from './resourceList/SwitchFilter'
import { deleteDistrict } from 'shared/api/mutations'

export function DistrictList() {
  const districtColumns = useDistrictColumns()
  const onBulkDelete = useCallback((ids: (number | string)[]) => {
    return deleteDistrict(ids as number[], true, true)
  }, [])
  return (
    <PaginatedResourceList
      title="Districts"
      resourceKey="districts"
      columns={districtColumns}
      header={<DistrictFilters />}
      onBulkDelete={onBulkDelete}
    />
  )
}

function DistrictFilters() {
  const navigate = useNavigateTo()
  const { create } = useResourceRoutes('districts')
  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        <StringFilter filterKey={'name'} label={'District Name / ID'} />
        <VerifiedSelect />
        <SwitchFilter
          label="Include Soft Deleted"
          filterKey="includeSoftDeleted"
        />
      </Box>
      <Box>
        <Button
          variant="text"
          startIcon={<Add />}
          onClick={() => navigate(create)}
        >
          Create
        </Button>
      </Box>
    </Box>
  )
}

function useDistrictColumns(): Column<List.District>[] {
  return useMemo(() => {
    return [
      {
        title: <SortableHeader title={'District Id'} id={'id'} />,
        width: 75,
        rowContent({ id }: List.District) {
          return id
        },
      },
      {
        title: <SortableHeader title={'District Name'} id={'name'} />,
        width: 600,
        rowContent({ name }: List.District) {
          return name
        },
      },
      {
        title: 'Created At',
        width: 75,
        rowContent({ created_at }: List.District) {
          return created_at
        },
      },
      {
        title: 'Is Verified',
        width: 100,
        rowContent({ is_verified }: List.District) {
          return is_verified ? '✓' : 'X'
        },
      },
      {
        title: 'Kiddom Access',
        width: 100,
        rowContent(district: List.District) {
          let status = (
            <span style={{ color: 'green', textAlign: 'center' }}>Enabled</span>
          )
          if (district.deleted_at !== null) {
            status = (
              <span style={{ color: 'red', textAlign: 'center' }}>Deleted</span>
            )
          }
          return status
        },
      },
    ]
  }, [])
}
